import LocalStorage from 'services/LocalStorage'
import { LocalStorageKey } from 'types/services/localStorage'

import { isGroupcalApp } from './appType'

export function isGuest() {
  return (
    isGroupcalApp() &&
    !LocalStorage.get(LocalStorageKey.PHONE_NUMBER) &&
    window.location.pathname.includes('/calendar')
  )
}
